import React from 'react';
import { Select } from 'antd';

const ACTIVITY_OPTIONS = [
  { value: 'expert comptable', label: 'Expert comptable' },
  { value: 'prestataire de paie', label: 'Prestataire de paie' },
  { value: 'conseil', label: 'Conseil' },
  { value: 'autre', label: 'Autre' },
];

/**
 * Dropdown "Activité du prestataire externe".
 *
 * Fonctionne :
 * - en mode autonome (InfoDetailUpdate.js) : onChange reçoit directement la valeur
 * - en enfant de Form.Item (autres formulaires) : value/onChange injectés par Ant Design Form
 */
const AccountingFirmActivitySelect = ({ value, onChange, ...rest }) => (
  <Select
    value={value}
    onChange={onChange}
    options={ACTIVITY_OPTIONS}
    placeholder="Sélectionnez une activité"
    {...rest}
  />
);

export default AccountingFirmActivitySelect;
